// extracted by mini-css-extract-plugin
module.exports = {"container":"BonusesRefundBlock_container__3LUBU","locked":"BonusesRefundBlock_locked__3ZgRY","balance":"BonusesRefundBlock_balance__30w-n"};